export enum PlanType {
  Paid = 'PAID',
  Trial = 'TRIAL',
  Freemium = 'FREEMIUM',
  Beta = 'BETA',
  Marketplace = 'MARKETPLACE',
  Offline = 'OFFLINE',
}

export interface Subscription {
  productSku: string
  quantity?: number
  status?: string
  planType?: PlanType
  currencyCode?: string
  productName?: string
  frequency?: string
  autoRenew?: boolean
  renewalPrice?: number
  startDate?: string
  endDate?: string
  subscriptionId: string
  renewalQuantity?: number
  pricePerLicencePerMonth?: number
  renewalDate?: string
  billingStartDate?: string
  billingEndDate?: string
  expiring?: boolean
  expiringInDays?: number
  daysRemainingInTerm?: number
  provisioningProducts?: ProvisioningProduct[]
  addOn?: boolean
  productFamilyKey?: string
}

export interface ProvisioningProduct {
  productSku: string
  displayName: string
  quantityMultiplier: number
}
